import getSpaceResizeConstraintForElement from './get-space-resize-constraint-for-element';

const getResizerElement = (element) => {
  const constraint = getSpaceResizeConstraintForElement(element);

  if (constraint && constraint.resizerElement) {
    return element.querySelector(constraint.resizerElement);
  }

  return element;
};

export default getResizerElement;
